import type { ComposeProps } from './components/Compose';
import type { FullComposeProps } from './components/FullCompose';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailCompose" */ './lazyIndex'),
    { name: 'MailCompose' }
);

// Delay loaded components
export const FullCompose: LazyComponent<FullComposeProps, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.FullCompose
);
export const Compose: LazyComponent<ComposeProps, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.Compose
);

export { editorScrollContainerClassName } from './components/body/scrollContainerClassName';
